<template>
  <section data-test="filter-number-family-member-scetion">
    <h4 class="text-base font-normal leading-none text-theme-33">
      จำนวนสมาชิก
    </h4>
    <div class="flex flex-nowrap justify-center items-center p-2">
      <input
        type="number"
        class="form-control form-control-sm text-center"
        placeholder="เริ่มต้น"
        v-model="startComputed"
      >
      <p class="inline-block mx-2">
        -
      </p>
      <input
        type="number"
        class="form-control form-control-sm text-center"
        placeholder="สิ้นสุด"
        v-model="endComputed"
      >
    </div>
  </section>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  modelValue: Object,
});
const emits = defineEmits(["update:modelValue"]);

const startComputed = computed({
  get() {
    return props.modelValue.start;
  },
  set(evt) {
    const result = { ...props.modelValue };
    result.start = evt;
    emits("update:modelValue", result);
  },
});
const endComputed = computed({
  get() {
    return props.modelValue.end;
  },
  set(evt) {
    const result = { ...props.modelValue };
    result.end = evt;
    emits("update:modelValue", result);
  },
});
</script>
